/**
 * @desc 查看数据维度信息
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.DataDimensionResponseDto>;
export function request(
  params: API.appCenter.dimension.info.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dimension/info`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
